module.exports = __webpack_public_path__ + "img/news-bg1.c976102d.jpg";